
import React from 'react';

export const PianoKeysIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M21 2H3c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 18H4V4h16v16zM6 6h2v8H6zm3 0h2v8H9zm6 0h2v8h-2zm-3 0h2v8h-2zM7.5 6h1v5h-1zm6 0h1v5h-1z"/>
  </svg>
);
